import ApiService from "@/services/api.service";

const state = {
  employees: [],
};

const getters = {
  getEmployees(state) {
    return state.users;
  },
};

const actions = {
  fetchEmployees({ commit }, payload) {
    return new Promise((resolve) => {
      ApiService.post("getemployees/", payload)
        .then(({ data }) => {
          commit("setEmployees", data.result);
          resolve(data);
        })
        .catch((e) => {
          commit("HANDLE_ERROR", e, {
            root: true,
          });
        });
    });
  },
};

const mutations = {
  setEmployees(state, payload) {
    state.employees = payload;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
